export const initialQuickbookOnlineSettings = {
  should_import_customers: [] as any,
  should_import_sub_customers: [] as any,
  should_import_projects: [] as any,
  billable_status: [] as any,
  create_bills_from_timesheets: [] as any,
};
